import React, { useState, useEffect } from "react";

const Section3 = ({ url,currentColor }) => {



  return (
    <section className="about-section-3">
       <div
          className={`panel color-${currentColor} section-3-container`}
          data-color="white"
        >
          <div
            className={`container panel-3-container`}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <div className="row panel-3-row">
              <div className="col-12 panel-3-txt">
                <h2 className="title">What Sets Us Apart</h2>
              </div>
              <div className="col-12 panel-3-counter">
                <div className="row counter-row">
                  <div className="counter-1 col-lg-6 col-md-6 col-12 counters">
                    <p className="title">Technology-First and AI-Led</p>
                    <p className="counter">
                      Solutions are built with a strong foundation in modern technologies and intelligent systems, ensuring long-term scalability and adaptability.
                    </p>
                  </div>
                  <div className="counter-2 col-lg-6 col-md-6 col-12 counters">
                    <p className="title">Outcome-Driven Approach</p>
                    <p className="counter">
                      Every engagement is aligned with clear business objectives, focusing on efficiency, growth, and measurable results rather than activity-based delivery.

                    </p>
                  </div>
                  <div className="counter-3 col-lg-6 col-md-6 col-12 counters">
                    <p className="title">Strategic Yet Practical</p>
                    <p className="counter">
                      The ability to balance big-picture thinking with hands-on execution ensures solutions are both innovative and implementable
                    </p>
                  </div>
                  <div className="counter-4 col-lg-6 col-md-6 col-12 counters">
                    <p className="title">Long-Term Partnership Mindset</p>
                    <p className="counter">
                      ExD Digital works as an extension of client teams, prioritizing trust, transparency, and sustained collaboration over short-term wins.

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
};

export default Section3;
